import { render, staticRenderFns } from "./ExtraSelector.vue?vue&type=template&id=4f70d761&scoped=true"
import script from "./ExtraSelector.vue?vue&type=script&lang=js"
export * from "./ExtraSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f70d761",
  null
  
)

export default component.exports